import React from 'react';
import { pdf, Font, Document, Page, Text, Image,View, StyleSheet } from '@react-pdf/renderer';
import Attachment from "../../../../assets/Icon/PdfIcon"; 
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaMd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-65Md.ttf'; 
import AigLogo from '../../../../assets/Logo/Aig.png';
 
 import { useTranslation } from 'react-i18next'; 

const formatDate = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month} ${year}`;
};
let primaryColor = "#16a3fe"
 

Font.register({
    family: 'HelveticaMd',  
    src: HelveticaMd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});



const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaMd', 
        backgroundColor: '#FFF',
        padding: 0,
    },

    header: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: '50px'
    },

    invoiceBox: {
        backgroundColor: primaryColor,
        color: '#fff',
        padding: '10px 10px 10px 100px',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },

    invoiceText: {
        color: '#fff',
        fontSize: '22px',
        fontFamily: 'HelveticaBold',
    },

    invoiceDateAndId: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        paddingRight: '30px',
    },

    invoiceDate: {
        marginBottom: '2px',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end'
    },

    invoiceDateText: {
        fontSize: '13px',
        paddingRight: '5px',
        family: 'HelveticaBold', 
    },

    invoiceDateIDText: {
        fontSize: '13px',
        color: '#777',
    },

    invoiceNumber: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end'
    },

    invoiceNumberText: {
        fontSize: '13px',
        paddingRight: '5px',
        family: 'HelveticaBold', 
    },

    invoiceNumberIDText: {
        fontSize: '13px',
        color: '#777',
    },

    invoiceToCompany: {
        marginTop: '70px',
        padding: '0 30px',
    },

    invoiceToCompanyBG: {
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        backgroundColor: '#eaeaea',
        padding: '20px 20px',
        boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)'
 
    },

    invoiceTo: {
        width: '50%',
        borderRight: '1px solid '+ primaryColor,
    },

    invoiceDesc: {
        width: '100%' 
    },
    invoiceCompany: {
        width: '50%',
        paddingLeft: '40px',
    },

    invoiceToHeader: { 
        fontSize: '16px',
        color: '#000',
        fontFamily: 'HelveticaBold',
        marginBottom: '8px',
    },

    invoiceCompanyHeader: { 
        fontSize: '16px',
        color: '#000',
        fontFamily: 'HelveticaBold',
        marginBottom: '8px',
    },

    invoiceToName: { 
        fontSize: '12px',
        color: '#000',
        marginBottom: '6px',
    },

    invoiceCompanyName: { 
        fontSize: '13px',
        color: '#000',
        marginBottom: '6px',
    },




    invoiceParam: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end',
        marginBottom: '1px',
    },

    invoiceParamText: {
        width: '25px',
        maxWidth: '25px',
        minWidth: '25px',
        color: '#000',
        fontSize: '12px', 
    },

    invoiceParamValue: {
        fontSize: '12px',
        color: '#666',
    },


    
    tableBox: { 
        padding: '0 30px',
        marginTop: '30px',
    }, 
    
    table: { 
        display: "table", 
        width: "auto", 
        borderStyle: "solid", 
        borderWidth: 0,   
        borderColor: '#fff',

    }, 
    
    tableRow: {   
        flexDirection: "row",  
    }, 

    tableCol: {  
        width: "20%", 
        borderStyle: "solid", 
        borderWidth: 2, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        borderColor: '#fff',
        backgroundColor: '#30343b',
        color: '#fff',
        padding: '10px',
        fontSize: 15,   
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-start',  
        justifyContent: 'center'  
    },  
    tableCell: { 
        lineHeight: .9,
        margin: "0", 
        fontFamily: 'HelveticaBold' 
    },
     
 
    
    tableBoxResult: { 
        padding: '0 30px',
        marginTop: '10px',
    }, 
    
    tableResult: { 
        display: "table", 
        width: "auto", 
        borderStyle: "solid", 
        borderWidth: 0,   
        borderColor: '#fff',

    }, 
    
    tableRowResult: {   
        flexDirection: "row",  
    }, 

    tableColResult: {  
        width: "20%", 
        borderStyle: "solid", 
        borderWidth: 2, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        borderColor: '#fff',
        backgroundColor: '#e2e3e6',
        color: '#000',
        padding: '10px',
        fontSize: 14,   
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-start',  
        justifyContent: 'center', 
        family: 'HelveticaBold', 
    }, 

    tableCellResult: { 
        lineHeight: .9,
        margin: "0",  
    },

    bankParam: {
        padding: '0 30px',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end',
        marginBottom: '4px',
    },

    bankParamText: {
        fontFamily: 'HelveticaBold',
        width: '130px',
        maxWidth: '130px',
        minWidth: '130px',
        color: '#000',
        fontSize: '16px', 
    },

    bankParamValue: {
        fontSize: '16px',
        color: '#555',
    },


    footer: { 
        marginTop: '30px',
        padding: '20px 30px', 
    },

    footerInner: {
        flexDirection: 'row', 
        justifyContent: 'space-evenly', 
    },

    footerLogo: {
        width: '40%',
        paddingRight: '10px',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-end', 
        borderRight: '1px solid '+ primaryColor,
    },
    footerDesc: {
        width: '60%',
        paddingLeft: '10px',
    },
     
    FooteParam: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end',
        marginBottom: '1px',
        fontSize: 14,   
        gap: '10px',
    },
    invoiceBtn: {borderRadius: 5, 
        lineHeight: "1.25", 
        fontWeight: "500", 
        padding: "6px 5px", 
        display: 'flex',
        fontSize: '14px',
        color: 'var(--text-color)', 
        background: 'var(--secondary-background)',
        border: '1px solid var(--border-color)', 
        transition: 'background-color 0.2s ease, border-color 0.2s ease', 
        alignItems: 'center',
        marginTop: '10px',
        gap: '10px',
        justifyContent: 'center'
    },

});



 


const MyDocument = ({ invoiceData }) => (
    <Document>

        <Page size="A4" style={styles.page}>
            <View style={styles.header}>

                <View style={styles.invoiceBox}>
                    <Text style={styles.invoiceText}>INVOICE</Text>
                </View>

                <View style={styles.invoiceDateAndId}>
                    <View style={styles.invoiceDate}>  
                        <Text style={styles.invoiceDateIDText}>{formatDate(invoiceData.created_date)}</Text>
                    </View>

                    <View style={styles.invoiceNumber}>
                        <Text style={styles.invoiceNumberIDText}>Invoice #00{invoiceData.id} </Text>
                    </View>
                </View>
            </View>
 
            <View style={styles.invoiceToCompany}>
                <View style={styles.invoiceToCompanyBG}>
                        <View style={styles.invoiceTo}>
                        <Text style={styles.invoiceToHeader}>Invoice To:</Text>
                        <Text style={styles.invoiceToName}>LLC Auto Import Georgia (406203120)</Text>
                        <Text style={styles.invoiceToName}>Guram Rostiashvili - Director</Text>
                        <Text style={styles.invoiceToName}>JSC "Bank of Georgia"</Text>
                        <Text style={styles.invoiceToName}>Account Number</Text> 
                        </View>

                        <View style={styles.invoiceCompany}>
                        <Text style={styles.invoiceCompanyHeader}>Pay To:</Text>
                        <Text style={styles.invoiceCompanyName}>Nika Potskhveria</Text>   
                        <Text style={styles.invoiceCompanyName}>Individual Entrepreneur Nika Potskhveria</Text>
                        <Text style={styles.invoiceCompanyName}>37001058182</Text>                            
                        <Text style={styles.invoiceCompanyName}>Account Number</Text>
                        <Text style={styles.invoiceCompanyName}>GE91BG0000000602917125</Text>
                        </View>

 
                </View>
            </View>

 
            <View style={{ marginTop: '5px',
        padding: '0 30px', }}>
                <View style={styles.invoiceToCompanyBG}>

                    <View style={styles.invoiceDesc}>
                        <Text style={styles.invoiceToHeader}>Description:</Text>
                        <Text style={styles.invoiceToName}> 

                                {
                                invoiceData.name === 'გამოყოფილი სერვერი' ? 'Dedicated Server' :
                                invoiceData.name === 'საპორტი' ? 'Support' : invoiceData.name
                                }
  

                        </Text>
                        
                    </View>
  

                </View>
            </View>

 
 
            <View style={{ display: 'flex', flexDirection: 'row',  alignItems: 'center', justifyContent: 'space-between', padding: '30px', }}> 
                 
                <View>
                    {invoiceData.is_paid ? <Text style={{ color: 'green'}}>Paid</Text> : <Text style={{ color: 'red'}}>Unpaid</Text>}
                </View> 
                 
                <View style={{  fontFamily: 'HelveticaBold', fontWeight: 'bold', fontSize: '18px', backgroundColor: primaryColor, padding: '10px 30px', color: '#fff',  }}> 
                    <Text style={{ marginTop: '0px',}}>
                        {invoiceData.amount} GEL
                    </Text> 
                </View>  
            </View>  

 

 

            <View style={styles.footer}>
                <View style={styles.footerInner}> 

                    <View style={styles.footerDesc}>
                            <View style={styles.FooteParam}>
                                <Text style={{marginBottom: '2px'}} >NETPARK</Text> 
                            </View>
                            <View style={styles.FooteParam}>
                                <Text style={{marginBottom: '4px'}}>Vazha-Pshavela 45, Tbilisi</Text> 
                            </View>
                            <View style={styles.FooteParam}>
                                <Text style={{ fontSize: '10px'}}>(+995) 555 82 84 84</Text> 
                                <Text style={{ fontSize: '10px', }}>info@netpark.ge</Text> 
                                <Text style={{ fontSize: '10px'}}>netpark.ge</Text> 
                            </View> 
                        </View>

 

                </View>
            </View>
            
            
        </Page>


    </Document>
);

const Invoice = ({  item}) => {
    const { t, i18n } = useTranslation();
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument invoiceData={item}   />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'invoice.pdf';
        link.click();
    };


    
    return ( <span style={styles.invoiceBtn} onClick={generatePDF}> 
    <Attachment style={{ height: '18px', width: '18px' }}  />
     {t('Invoice')}</span> );
        
 
};

export default Invoice;
